



















import {
  computed, defineComponent, inject, PropType, useFetch, ref
} from '@nuxtjs/composition-api';
import FilterBox from 'components/catalog/Category/Filters/Renderer/FilterBox.vue';
import type { Aggregation } from '@wemade-vsf/magento-api';
import { useWmAttributes } from '@wemade-vsf/catalog/lib/runtime/product/composables/useWmAttributes';
import Swatch from 'components/catalog/Swatch.vue'

interface SwatchOption {
  label: string,
  type: string,
  value: string,
  color: string
}

export default defineComponent({
  components: {
    FilterBox,
    Swatch
  },
  props: {
    filter: {
      type: Object as PropType<Aggregation>,
      required: true,
    },
    open: {
      type: Boolean,
      default: true
    }
  },
  setup(props) {
    const { getSwatchData } = useWmAttributes();
    const { isFilterSelected } = inject('UseFiltersProvider');
    const swatches = ref<SwatchOption[]|null>(null);
    const filterOptions = computed(() => props.filter.options?.map(o => o.label ))
    const selected = computed(() => ((id: string, optVal: string) => isFilterSelected(id, optVal)));
    const visibleSwatches = computed(() => {
      if (!swatches.value || !swatches.value.length) return null
      return swatches.value.filter(s => filterOptions.value.includes(s.value))
    })
    useFetch(async() => {
      const result = await getSwatchData(props.filter.attribute_code);
      if (result) {
        swatches.value = result.reduce((prev: SwatchOption[], current) => {
          prev.push({
            label: current.label,
            value: current.label,
            type: current.type,
            color: current.value
          })
          return prev;
        }, [])
      }
      
    })

    return {
      selected,
      visibleSwatches
    };
  },
});
